import { Tabs } from '@lambdacurry/component-library';
import { observer } from 'mobx-react';
import React, { useEffect, useReducer } from 'react';
import useStore from '../../../store/useStore';
import { LeadViewInitialState, LeadViewReducer } from './LeadView.helpers';
import { LeadViewCalendar } from './LeadViewCalendar';
import { LeadViewList } from './LeadViewList';
import { AppSectionHeader } from '../../../components-v2/shared';
import { FiltersSelector, useFilters } from '../../Filters/Filters';
import './lead-view.scss';
import { BooleanParam, useQueryParam } from 'use-query-params';
export const LeadView = observer(() => {
    const { store } = useStore();
    const { router } = store;

    const [state, dispatch] = useReducer(LeadViewReducer, LeadViewInitialState);
    const { filters, setFilters } = useFilters();

    const [isListView, setListView] = useQueryParam('listView', BooleanParam);

    useEffect(() => {
        dispatch({ name: 'setTabValue', payload: isListView === false ? 1 : 0 });
    }, [isListView, router.currentPath]);

    return (
        <div className="lead-view">
            <AppSectionHeader title="Leads">
                <div className="filters">
                    <FiltersSelector showDateRange={state.tabValue === 0} />
                </div>
            </AppSectionHeader>
            <Tabs
                value={state.tabValue}
                onChange={(event, value) => {
                    if (value === 0) {
                        setListView(true, 'replaceIn');
                    } else {
                        setListView(false, 'replaceIn');
                    }

                    dispatch({ name: 'setTabValue', payload: value });
                }}
                tabs={[
                    {
                        label: 'Lead List',
                        render:
                            filters && setFilters ? (
                                <LeadViewList
                                    state={state}
                                    dispatch={dispatch}
                                    filters={filters}
                                    setFilters={setFilters}
                                />
                            ) : null
                    },
                    {
                        label: 'Lead Calendar',
                        render: <LeadViewCalendar state={state} dispatch={dispatch} />
                    }

                ]}
            />
        </div>
    );
});
